import { call, put, take, fork, cancel } from 'redux-saga/effects';
import apiSaga from './apiSaga';
import { isEmpty } from 'lodash';
import { SEARCH_TAGS, CLEAR_TAGS } from 'actionTypes';
import { searchTagsSuccess } from 'actions';

function* searchTagsAPISaga(action) {
  let response = yield call(apiSaga, action);
  if (isEmpty(response.errors)) {
    yield put(searchTagsSuccess(action.endpointArgs.name, response));
  }
}

function* searchTagsSaga() {
  let task;
  while (true) {
    let action = yield take('*');
    switch (action.type) {
      case SEARCH_TAGS:
        if (task) {
          yield cancel(task);
        }
        task = yield fork(searchTagsAPISaga, action);
        break;
      case CLEAR_TAGS:
        yield cancel(task);
        break;
      default:
        break;
    }
  }
}

export default searchTagsSaga();



// WEBPACK FOOTER //
// ./src/sagas/tagSagas.js